module.exports = __webpack_public_path__ + "static/media/carter.f38cb32a.jpg";